import React from 'react';
import { Text } from '@wix/design-system';
import { useTermsAndConditionsText } from '../hooks/useTermsAndConditionsText';
export const TermsAndConditions = _ref => {
  let {
    darkCtas
  } = _ref;
  const termsAndConditionsText = useTermsAndConditionsText({
    darkCtas
  });
  return /*#__PURE__*/React.createElement(Text, {
    dataHook: "terms-and-conditions",
    size: "small",
    weight: "thin"
  }, termsAndConditionsText);
};
//# sourceMappingURL=TermsAndConditions.js.map